import { createPortal } from 'react-dom';

import type { ScheduledOrderDetail } from '../domain';
import { ScheduledOrderInvoice } from './ScheduledOrderInvoice';

interface Props {
  detail: ScheduledOrderDetail | null;
}

/* ! Mirrors the proven kanban print flow (PrintManagement): the invoice stays
 *   mounted while the detail is available — hidden via `display:none`, shown only
 *   under `@media print` — so its JSS styles are injected and its layout resolved
 *   BEFORE printing. Mounting on-demand + rAF made `window.print()` fire before the
 *   `@media print` styles were ready, which hung the print preview. */
export function ScheduledOrderInvoicePortal({ detail }: Props) {
  if (!detail) return null;

  return createPortal(<ScheduledOrderInvoice detail={detail} />, document.body);
}
